export enum VideoPlayMode {
  Autoplay = "autoplay",
  Manual = "manual",
  Unset = "unset",
}
